import { render, staticRenderFns } from "./addTags.vue?vue&type=template&id=e33fcd7e&scoped=true"
import script from "./addTags.vue?vue&type=script&lang=js"
export * from "./addTags.vue?vue&type=script&lang=js"
import style0 from "./addTags.vue?vue&type=style&index=0&id=e33fcd7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33fcd7e",
  null
  
)

export default component.exports